import React, { useState } from "react";
import PropTypes from "prop-types";
import CardSkeleton from "../../ui/Skeleton/CardSkeleton";
import { classNames } from "../../../utils/helpers";
import Icon from "../../Icon";
import { FormatInt } from "../../../utils/FormatData";
import _ModalError from "../../modal/dashboard/sms/_ModalError";
import _Button from "../../generic/_Button";
const ErrorCard = (props) => {
  const { data, loading } = props;

  const [visible, setVisible] = useState(false);
  if (loading) return <CardSkeleton />;

  return (
    <div
      className={classNames(
        "flex flex-col p-6 transition-all duration-300 transform bg-white rounded-lg bg-primary/10 hover:scale-105 grid-cols-1 gap-4",
      )}
    >
      <div className="flex flex-col h-full">
        <div>
          <div className="flex items-center justify-between">
            <div className="text-lg font-bold text-gray-600 dark:text-background-light pb-3">
              Errores
            </div>
            <Icon icon="error" size={36} className={"text-orange-600"} />
          </div>

          <p className="mt-2 text-3xl font-bold text-[#101922] dark:text-background-light">
            {FormatInt(data?.i_errors ?? 0)}
          </p>
        </div>

        <_Button
          className="mt-auto"
          icon="read_more"
          style="none"
          title="Ver Detalles"
          onClick={() => setVisible(true)}
        />
      </div>

      <_ModalError
        visible={visible}
        title="Detalles Errores"
        onClose={() => setVisible(false)}
      />
    </div>
  );
};

ErrorCard.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};
export default ErrorCard;
